@if (isStdCheck) {
  <div class="primary title">
    <div class="container">
      <div class="columns mx-0">
        <div class="column">
          <h1>We Found <span>A Better Lab!</span></h1>
        </div>
      </div>
    </div>
  </div>
}
<div id="betterlab-container" class="px-0 pt-4 pb-6 main container">
  @if (isHealthlabs) {
    <h1 class="is-size-1 has-text-centered">We Found A Better Lab!</h1>
  }

  <div class="container p-0" data-qa-id="Order Place Message Container">
    <div class="columns mx-3 p-0">
      <div class="column p-0">
        <div class="better-lab-banner">
          <span class="better-lab-banner__icon">
            <img src="assets/img/better-lab-arrow.png" alt="" aria-hidden="true" />
          </span>
          <div>
            <p class="better-lab-banner__title">Choose a faster lab below!</p>
            <p class="better-lab-banner__subtitle">
              We have identified nearby labs that can process your test quicker.
            </p>
            <p class="better-lab-banner__subtitle">
              Selecting one of the recommended options below may help you get results sooner.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  @if (center) {
    <div class="container mt-5 p-0" data-qa-id="Current Test Center">
      <div class="columns mx-3 p-0">
        <div class="column p-0">
          <div class="notification p-4" [ngClass]="betterLabStyles.currentTestCenterNotificationClass">
            <div class="columns">
              <div class="column is-6">Currently selected location:</div>
              <div class="column is-6">
                <b>
                  {{ center.address }}
                  <br />
                  {{ center.city }}, {{ center.state }} {{ center.zip_code }}
                </b>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
  <div class="container pt-5" data-qa-id="Find a Better Lab">
    <div class="columns mx-0">
      <div class="column">
        <app-test-center
          [showHeader]="false"
          [showSelectedCenter]="false"
          [reEnableButtons]="hasError"
          [inHomeCollection]="false"
          [zipCode]="orderLabZipCode"
          [tests]="orderedTests"
        ></app-test-center>
      </div>
    </div>
    @if (betterLabError) {
      <div class="columns mx-0">
        <div class="column">
          <app-error-notification classes="has-text-centered" data-qa-id="Better Lab Error Notification">
            {{ betterLabError }}
          </app-error-notification>
        </div>
      </div>
    }
  </div>
  <div class="container mt-1">
    <div class="columns mx-0">
      <div class="column is-flex is-justify-content-end">
        <button
          type="button"
          data-qa-id="Keep Current Lab Link"
          class="better-lab-keep-link"
          (click)="onKeepCurrentLab()"
        >
          No thanks, I'll keep the current lab <i class="fa fa-arrow-right ml-2" aria-hidden="true"></i>
        </button>
      </div>
    </div>
  </div>
</div>
